/* tslint:disable */
/* eslint-disable */
/**
 * Muscula App API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddUserToProjectRequest,
  AddUserToProjectResponse,
  ApiErrorResponse,
  BaseAppInformationGenericApiResponse,
  CreateResponseGenericApiResponse,
  ProjectCreateRequest,
  ProjectListDtoListGenericApiResponse,
  SuccessfullApiResponse,
} from '../models';
import {
    AddUserToProjectRequestFromJSON,
    AddUserToProjectRequestToJSON,
    AddUserToProjectResponseFromJSON,
    AddUserToProjectResponseToJSON,
    ApiErrorResponseFromJSON,
    ApiErrorResponseToJSON,
    BaseAppInformationGenericApiResponseFromJSON,
    BaseAppInformationGenericApiResponseToJSON,
    CreateResponseGenericApiResponseFromJSON,
    CreateResponseGenericApiResponseToJSON,
    ProjectCreateRequestFromJSON,
    ProjectCreateRequestToJSON,
    ProjectListDtoListGenericApiResponseFromJSON,
    ProjectListDtoListGenericApiResponseToJSON,
    SuccessfullApiResponseFromJSON,
    SuccessfullApiResponseToJSON,
} from '../models';

export interface ApiProjectsNewPostRequest {
    projectCreateRequest?: ProjectCreateRequest;
}

export interface ApiProjectsProjectIdDeleteRequest {
    projectId: string;
}

export interface ApiProjectsProjectIdPutRequest {
    projectId: string;
    projectCreateRequest?: ProjectCreateRequest;
}

export interface ApiProjectsUsersPostRequest {
    addUserToProjectRequest?: AddUserToProjectRequest;
}

export interface ApiProjectsUsersProjectIdUserIdDeleteRequest {
    projectId: string;
    userId: string;
}

/**
 * 
 */
export class ProjectsApi extends runtime.BaseAPI {

    /**
     */
    async apiProjectsBaseAppInformationGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BaseAppInformationGenericApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Projects/BaseAppInformation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BaseAppInformationGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiProjectsBaseAppInformationGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BaseAppInformationGenericApiResponse> {
        const response = await this.apiProjectsBaseAppInformationGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiProjectsListGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectListDtoListGenericApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Projects/List`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectListDtoListGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiProjectsListGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectListDtoListGenericApiResponse> {
        const response = await this.apiProjectsListGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiProjectsNewPostRaw(requestParameters: ApiProjectsNewPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateResponseGenericApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/Projects/New`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectCreateRequestToJSON(requestParameters.projectCreateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateResponseGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiProjectsNewPost(requestParameters: ApiProjectsNewPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateResponseGenericApiResponse> {
        const response = await this.apiProjectsNewPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiProjectsProjectIdDeleteRaw(requestParameters: ApiProjectsProjectIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling apiProjectsProjectIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Projects/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiProjectsProjectIdDelete(requestParameters: ApiProjectsProjectIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.apiProjectsProjectIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiProjectsProjectIdPutRaw(requestParameters: ApiProjectsProjectIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling apiProjectsProjectIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/Projects/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectCreateRequestToJSON(requestParameters.projectCreateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiProjectsProjectIdPut(requestParameters: ApiProjectsProjectIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.apiProjectsProjectIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiProjectsUsersPostRaw(requestParameters: ApiProjectsUsersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddUserToProjectResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/Projects/users`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddUserToProjectRequestToJSON(requestParameters.addUserToProjectRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddUserToProjectResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiProjectsUsersPost(requestParameters: ApiProjectsUsersPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddUserToProjectResponse> {
        const response = await this.apiProjectsUsersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiProjectsUsersProjectIdUserIdDeleteRaw(requestParameters: ApiProjectsUsersProjectIdUserIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling apiProjectsUsersProjectIdUserIdDelete.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling apiProjectsUsersProjectIdUserIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Projects/users/{projectId}/{userId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiProjectsUsersProjectIdUserIdDelete(requestParameters: ApiProjectsUsersProjectIdUserIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.apiProjectsUsersProjectIdUserIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
